//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    custom_title: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false,
      token: null,
      tokens: ['', '', '', '']
    };
  },
  methods: {
    onClose: function onClose() {
      this.isOpen = false;
    },
    onOpen: function onOpen() {
      this.isOpen = true;
    },
    onSend: function onSend() {
      var num = this.tokens.join('');
      console.log(num);
      this.$emit("sendToken", num);
    },
    moveFocus: function moveFocus(event, index) {
      console.log(event, index);
      if (index > 0 && index < this.tokens.length) {
        this.$refs.tokenFields[index] ? this.$refs.tokenFields[index].focus() : null; // Comprobar si el campo siguiente existe antes de mover el cursor
      }
    }
  }
};